import UartChannel from './UartChannel';

function calcChecksumV1(buffer, start, end) {
  let checksum = 0;
  for (let index = start; index < end; index++) {
    checksum = (checksum + buffer [index]) & 0x7F;
  }
  return (checksum ^ 0x7F);
}

function calcAndCompareChecksumV1(buffer, start, end) {
  const checksum = calcChecksumV1(buffer, start, end - 1);
  return (checksum === buffer [end - 1]);
}

function calcAndSetChecksumV1(buffer, start, end) {
  const checksum = calcChecksumV1(buffer, start, end - 1);
  buffer [end - 1] = checksum;
}

function injectSeptett(srcBuffer, srcStart, srcEnd, dstBuffer, dstStart) {
  const septett = srcBuffer [srcEnd];
  let srcIndex = srcStart, dstIndex = dstStart, mask = 1;
  while (srcIndex < srcEnd) {
      let b = srcBuffer [srcIndex];
      if (septett & mask) {
          b |= 0x80;
      }
      dstBuffer [dstIndex] = b;

      srcIndex++;
      dstIndex++;
      mask = mask << 1;
  }
}

function extractSeptett(srcBuffer, srcStart, srcEnd, dstBuffer, dstStart) {
  let srcIndex = srcStart, dstIndex = dstStart, mask = 1, septett = 0;
  while (srcIndex < srcEnd) {
      let b = srcBuffer [srcIndex];
      if (b & 0x80) {
          b &= 0x7F;
          septett |= mask;
      }
      dstBuffer [dstIndex] = b;

      srcIndex++;
      dstIndex++;
      mask = mask << 1;
  }

  dstBuffer [dstIndex] = septett;
}

export default class VBusChannel extends UartChannel {
  constructor(name, sendCallback) {
    super(name, sendCallback);

    this.rxBuffer = Buffer.alloc(772);
    this.rxIndex = -1;
  }

  receiveData(data) {
    if (data === 0xAA) {
      this.rxIndex = 0;
    } else if (data & 0x80) {
      this.rxIndex = -1;
    }

    if (this.rxIndex < 0) {
      // nop
    } else if (this.rxIndex >= this.rxBuffer.length) {
      this.rxIndex = -1;
    } else {
      this.rxBuffer [this.rxIndex] = data;
      this.rxIndex += 1;

      let expectedLength;
      if (this.rxIndex < 6) {
        expectedLength = null;
      } else if (this.rxBuffer [5] === 0x10) {
        if (this.rxIndex < 10) {
          expectedLength = null;
        } else {
          if (this.rxIndex === 10) {
            if (!calcAndCompareChecksumV1(this.rxBuffer, 1, 10)) {
              this.rxIndex = -1;
            }
          } else if ((this.rxIndex > 10) && (((this.rxIndex - 10) % 6) === 0)) {
            if (!calcAndCompareChecksumV1(this.rxBuffer, this.rxIndex - 6, this.rxIndex)) {
              this.rxIndex = -1;
            }
          }

          if (this.rxIndex < 10) {
            expectedLength = null;
          } else {
            expectedLength = 10 + this.rxBuffer [8] * 6;
          }
        }
      } else if (this.rxBuffer [5] === 0x20) {
        if (this.rxIndex === 16) {
          if (!calcAndCompareChecksumV1(this.rxBuffer, 1, 16)) {
            this.rxIndex = -1;
          }
        }

        expectedLength = 16;
      } else if (this.rxBuffer [5] === 0x30) {
        if (this.rxIndex === 8) {
          if (!calcAndCompareChecksumV1(this.rxBuffer, 1, 8)) {
            this.rxIndex = -1;
          }
        } else if ((this.rxIndex > 8) && (((this.rxIndex - 8) % 9) === 0)) {
          if (!calcAndCompareChecksumV1(this.rxBuffer, this.rxIndex - 9, this.rxIndex)) {
            this.rxIndex = -1;
          }
        }

        if (this.rxIndex < 8) {
          expectedLength = null;
        } else {
          expectedLength = 8 + (this.rxBuffer [6] >> 5) * 9;
        }
      } else {
        expectedLength = null;
      }

      if (expectedLength == null) {
        // nop
      } else if (this.rxIndex != expectedLength) {
        // nop
      } else if (this.rxBuffer [5] === 0x10) {
        // console.log(this.name, this.rxBuffer.slice(0, 9).toString('hex'));
        const destinationAddress = this.rxBuffer.readUInt16LE(1);
        const sourceAddress = this.rxBuffer.readUInt16LE(3);
        const protocolVersion = this.rxBuffer [5];
        const command = this.rxBuffer.readUInt16LE(6);
        const frameCount = this.rxBuffer [8];
        const frameData = Buffer.alloc(127 * 4);
        frameData.fill(0);
        for (let frameIndex = 0; frameIndex < frameCount; frameIndex++) {
          const sourceStart = 10 + frameIndex * 6;
          const targetStart = frameIndex * 4;
          injectSeptett(this.rxBuffer, sourceStart, sourceStart + 4, frameData, targetStart);
        }
        this.emit('packet', {
          timestamp: new Date(),
          destinationAddress,
          sourceAddress,
          protocolVersion,
          command,
          frameCount,
          frameData,
        });
        
        this.rxIndex = -1;
      } else if (this.rxBuffer [5] === 0x20) {
        const destinationAddress = this.rxBuffer.readUInt16LE(1);
        const sourceAddress = this.rxBuffer.readUInt16LE(3);
        const protocolVersion = this.rxBuffer [5];
        const command = this.rxBuffer.readUInt16LE(6);
        const valueId = this.rxBuffer.readUInt16LE(8);
        const value = this.rxBuffer.readInt32LE(10);

        this.emit('datagram', {
          timestamp: new Date(),
          destinationAddress,
          sourceAddress,
          protocolVersion,
          command,
          valueId,
          value,
        });

        this.rxIndex = -1;
      } else if (this.rxBuffer [5] === 0x30) {
        const destinationAddress = this.rxBuffer.readUInt16LE(1);
        const sourceAddress = this.rxBuffer.readUInt16LE(3);
        const protocolVersion = this.rxBuffer [5];
        const command = this.rxBuffer [6];
        const frameCount = command >> 5;
        const frameData = Buffer.alloc(21);
        for (let frameIndex = 0; frameIndex < frameCount; frameIndex++) {
          const srcStart = 8 + frameIndex * 9;
          injectSeptett(this.rxBuffer, srcStart, srcStart + 8, frameData, frameIndex * 7);
        }

        this.emit('telegram', {
          timestamp: new Date(),
          destinationAddress,
          sourceAddress,
          protocolVersion,
          command,
          frameCount,
          frameData,
        });

        this.rxIndex = -1;
      } else {
        throw new Error(`Invalid state`);
      }
    }
  }

  send(origData) {
    let data;
    if (!origData) {
      data = origData;
    } else if (origData instanceof Buffer) {
      data = origData;
    } else if (origData.protocolVersion === 0x30) {
      data = Buffer.alloc(8 + origData.frameCount * 9);
      data [0] = 0xAA;
      data.writeInt16LE(origData.destinationAddress, 1);
      data.writeInt16LE(origData.sourceAddress, 3);
      data [5] = origData.protocolVersion;
      data [6] = origData.command;
      calcAndSetChecksumV1(data, 1, 8);

      for (let frameIndex = 0; frameIndex < origData.frameCount; frameIndex++) {
        const srcStart = frameIndex * 7;
        const dstStart = 8 + frameIndex * 9;

        extractSeptett(origData.frameData, srcStart, srcStart + 7, data, dstStart);
        calcAndSetChecksumV1(data, dstStart, dstStart + 9);
      }
    } else {
      throw new Error(`Unsupported data argument`);
    }

    return UartChannel.prototype.send.call(this, data);
  }
}